module.exports = __webpack_public_path__ + "img/five.7bf39afe.jpg";